import AdditionCostCaption from '@components/pages/Products/components/RouteProduct/components/AdditionCostCaption';
import {
  getCost,
  getRowsData,
} from '@components/pages/Products/components/RouteProduct/components/ProductRouteItem/helpers';
import RouteProductDetailSteps from '@components/pages/Products/components/RouteProduct/components/RouteProductDetailSteps';
import OfferDetailTableHeaderData from '@components/pages/Products/components/RouteProduct/components/ShoulderItemHeaderData';
import ShoulderItemTable from '@components/pages/Products/components/RouteProduct/components/ShoulderItemTable';
import TerminalsInfo from '@components/pages/Products/components/RouteProduct/components/TerminalsInfo';
import getRouteSummary from '@components/pages/Products/components/RouteProduct/getRouteSummary';
import { getCargoParams } from '@components/pages/Products/components/RouteProduct/helpres';
import { RouteProductContextData } from '@components/pages/Products/components/RouteProduct/types';
import ServiceSummaryComp from '@components/pages/Products/components/ServiceSummary';
import { getLocalizationById } from '@context/useMyRouting/helpers';
import { useYaHit } from '@context/useYaHit';
import { TaxNameProps } from '@helpers/getTaxNames';
import Typography from '@mui/material/Typography';
import { RouteWidgetBaseParameters } from '@pages/AdditionalServices/tabs/DeliveryForm/types';
import ShoulderItemDetailsDTO from '@services/collectors/ProductService/ShoulderItemDetailsDTO';
import { Order } from '@services/requests/orderService/interface';
import {
  ContainerParameters,
  CustomCargoParameters,
  RouteInGroup,
  TruckParameters,
} from '@services/requests/orderService/types';
import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Пропсы компонента
 */
type ProductRouteItemProps = {
  order: Order;
  cargo: string;
  route: RouteInGroup;
  taxNames: TaxNameProps[];
  cargoType: 'container' | 'custom' | 'truck';
  containerParameters: ContainerParameters[];
  customCargoParameters: CustomCargoParameters[];
  truckParameters: TruckParameters[];
  realTimeBaseData: RouteWidgetBaseParameters;
  isUseActualCourses: boolean;
  routeIndex: number;
  routes: RouteInGroup[];
} & RouteProductContextData;

/**
 * Компонент вывода продукта маршрута
 * @param props
 * @constructor
 */
const ProductRouteItem = (props: ProductRouteItemProps) => {
  const {
    cargoType,
    route,
    containerParameters,
    customCargoParameters,
    truckParameters,
    taxNames,
    realTimeBaseData,
    order,
    isUseActualCourses,
    routeIndex,
    routes,
  } = props;
  const langCode = getLocalizationById(order.language_id).countryCode;
  const { t } = useTranslation(['Common', 'OfferDetail'], { lng: langCode });

  useYaHit({});

  const {
    containerRent,
    containerRentCalculatedPrice,
    pickOn,
    pickOnCalculatedPrice,
    dropOff,
    dropOffCalculatedPrice,
  } = route;

  if (!realTimeBaseData) {
    return null;
  }

  const cargoParameters = getCargoParams(
    cargoType,
    containerParameters,
    customCargoParameters,
    truckParameters,
    route
  );

  if (!cargoParameters) {
    return null;
  }

  const steps = route.steps;
  const names = {
    pickOn: t('OfferDetail:CostIssuingContainer'),
    containerRent: t('OfferDetail:ContainerRentalCost'),
    dropOff: t('OfferDetail:ContainerReturnCost'),
  };
  const currencies = isUseActualCourses
    ? realTimeBaseData.currencies
    : props.productData.baseData.currencies;

  const cost = getCost(containerRentCalculatedPrice, pickOnCalculatedPrice, dropOffCalculatedPrice);

  const currencyRoute = currencies.find((c) => props.currencyRoute.id === c.id);
  const targetCurrency = currencies.find((c) => props.currencyRoute.id === c.id);
  const pickOnCurrency = currencies.find((c) => pickOn?.currency_id === c.id) || targetCurrency;
  const dropOffCurrency = currencies.find((c) => dropOff?.currency_id === c.id) || targetCurrency;
  const containerRentCurrency =
    currencies.find((c) => containerRent?.currency_id === c.id) || targetCurrency;

  const column = OfferDetailTableHeaderData(currencyRoute, order);

  const rowsData = getRowsData({
    targetCurrency,
    realTimeBaseData,
    pickOn,
    pickOnCalculatedPrice,
    dropOff,
    dropOffCalculatedPrice,
    containerRent,
    containerRentCalculatedPrice,
    taxNames,
    names,
    pickOnCurrency,
    dropOffCurrency,
    containerRentCurrency,
  });

  const rows = ShoulderItemDetailsDTO(rowsData);

  return (
    <>
      <div>
        <Typography variant={'h2'} className={'heading'}>
          {t('Common:Delivery')}
        </Typography>
      </div>
      {!!steps?.length && (
        <RouteProductDetailSteps
          steps={steps}
          routes={routes}
          taxNames={taxNames}
          order={order}
          isUseActualCourses={isUseActualCourses}
          routeIndex={routeIndex}
          cargoType={cargoType}
          containerParameters={containerParameters}
          customCargoParameters={customCargoParameters}
          truckParameters={truckParameters}
        />
      )}
      <TerminalsInfo
        steps={steps}
        taxNames={taxNames}
        order={order}
        isUseActualCourses={isUseActualCourses}
      />
      {cost !== 0 && (
        <div className={'additional-service-table kendo-pdf--prevent-split'}>
          <ShoulderItemTable
            header={
              <AdditionCostCaption cost={cost} targetCurrency={currencyRoute} order={order} />
            }
            rows={rows}
            columns={column}
          />
        </div>
      )}
      <ServiceSummaryComp
        summary={getRouteSummary(
          [route],
          props.productData.baseData.currencies,
          currencyRoute.code,
          true
        )}
        title={`${t('Common:Total')} ${t('Common:Delivery')}`}
        order={order}
      />
    </>
  );
};

export default ProductRouteItem;
